import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/customer-route-plans', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/customer-route-plans', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/customer-route-plans/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const show = id => {
  return httpClient
    .get(`/api/v1/customer-route-plans/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

// export const user = (Options = {}) => {
//   return httpClient
//     .get('/api/v1/customer-route-plans/users', Options)
//     .then(response => Promise.resolve(response.data))
//     .catch(error => Promise.reject(error.response.data))
// }

export const getCommuneInDistrict = data => {
  return httpClient
    .post('/api/v1/customer-route-plans/commune-districts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getShop = data => {
  return httpClient
    .post('/api/v1/customer-route-plans/shop-list-in-communes', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/v1/customer-route-plans/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, update, show, getShop, getCommuneInDistrict, formViewModel }